import React, { Component} from 'react';

import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';

import { observer, inject } from 'mobx-react';


const style = {
    height: 350,
    width: 400,
    margin: 20,
    borderRadius: 10,
    textAlign: 'center',
    display: 'inline-block',
};

class ChangePassword extends Component {

    render() {
        return (
            <div style={{width: 500, margin: 'auto'}}>
                <Paper style={style} elevation={1}>
                    <div style={{width: 250, margin: 'auto'}}>
                        <br/>
                        <span style={{color: '#1565c0', fontSize: 20}}>Change password</span>
                        <br/>
                        <br/>
                        <TextField
                            id="password"
                            label="Old password"
                            fullWidth={true}
                            type="password"
                        />
                        <br />
                        <br />
                        <TextField
                            id="password"
                            label="New password"
                            fullWidth={true}
                            type="password"
                        />
                        <br />
                        <TextField
                            id="password"
                            label="Repeat new password"
                            fullWidth={true}
                            type="password"
                        />
                        <br />
                        <br />
                        <Button variant="contained" color="primary" style={{marginRight: 10}}>Clear</Button>
                        <Button variant="contained" color="primary" style={{marginLeft: 10}}>Change</Button>
                    </div>
                </Paper>
            </div>
        )
    }
}

export default inject("Auth")(observer(ChangePassword))
